import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import PageHeader from 'lib/designSystem/PageHeader';
import React from 'react';

export interface NonNomineeDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const NonNomineeDialog: React.FC<NonNomineeDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <PageHeader variant="dialogHeader">
          <PageHeader.TitleSection
            title="Pago sin nómina"
            subtitle="¿Estás seguro de querer continuar?"
            iconType="payment"
          />
        </PageHeader>
        <Typography variant="body1">
          Esto se hace para facturas que ya fueron pagadas sin un pago directo.
          Normalmente utilizado en prestamos con descuentos o ventas con
          descuentos.
        </Typography>
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={onClose}>
          Cancelar
        </CustomButton>
        <CustomButton color="primary" onClick={onConfirm}>
          Marcar como pagado
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NonNomineeDialog;
